module.exports = __webpack_public_path__ + "static/media/night3.50615e00.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night3.jpeg
// module id = 26
// module chunks = 0